var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoalsNotStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 203,
    height: 205,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M202.14 195H19.99v9.58h182.15V195Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#29ABCC",
    d: "M157.14 84.39h-10.28v32.09h10.28V84.39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3656B3",
    d: "M174.19 96.67h-10.28v19.8h10.28v-19.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFADC",
    d: "M191.07 103.66h-10.28v12.81h10.28v-12.81Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M49.4 81.96s-9 42 10.11 45.13c23.59 3.89 32.07-29.61 53.45-30.4 10.67-.4 13.1 8.89 15.32 15.68 6.66 20.44-11 64.8-60.83 62.88-55.44-2.12-42.18-79.4-31.27-93.18l13.22-.11Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB850",
    d: "M105.47 165.32c-4.6-3.08-13.63-7.5-24.79-4.77a31.828 31.828 0 0 0-19.84 14.06c2.188.352 4.395.569 6.61.65 15.85.6 28.43-3.47 38.02-9.94Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#29ABCC",
    d: "M105.47 165.32c-4.6-3.08-13.63-7.5-24.79-4.77a31.828 31.828 0 0 0-19.84 14.06c2.188.352 4.395.569 6.61.65 15.85.6 28.43-3.47 38.02-9.94Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m124.04 144.02-9.85-19.27s.93 37.36-40.34 39.1c-41.27 1.74-47.2-37-47.2-37 .72 23.66 10.51 47.26 40.8 48.42 29.84 1.13 48.19-14.3 56.59-31.25Z",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M57.24 68.63a2.64 2.64 0 0 0-2.4-2c-2.24-.27-5.61 1.39-8.32 2.71a2.79 2.79 0 0 1-1.16.34c-.5-.63-2.76-3.48-3.37-4.12-.32-.33-.71-.77-1.11-1.23-1.4-1.61-3.14-3.61-4.69-4.21-1.74-.68-2.63 0-2.91.31a2.099 2.099 0 0 0-.53-.24 2.46 2.46 0 0 0-2.53.88 2.701 2.701 0 0 0-2.44-.25 1.89 1.89 0 0 0-1.1 1.57c-.45 4.18 6 10 8.08 11.32 2.08 1.32 1.43 8.31 1.42 8.36-.01.05 1.32 1.59 6.05 1.85 5.45.31 6.94-.79 7-.9.74-3.47.47-8.22 1.38-9a11.647 11.647 0 0 1 3.35-1.89c.41-.17.79-.33 1.17-.51 2.18-1.06 2.2-2.44 2.11-2.99Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#C65347",
    d: "M44.9 74.14c-.52-4.77-7.94-5.47-8-5.48-1.63-1.39-6.64-7.18-6.85-7.42.43-.27 5.44 5.52 7 6.93.9.09 7.86 1 8.14 5.71-.28.26-.28.26-.29.26Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#C65347",
    d: "M41.06 69.66c-.19-.08-8-9.06-8-9.06.38-.33 8.16 8.65 8.16 8.65-.04.39-.1.41-.16.41Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB850",
    d: "M119.21 96.81s-4.92-2.33-5.91-1.7c-14.55 9.19-25 22.84-26.72 36.55-1.12 8.64 3.41 23 3.74 39.26-.28 10.83-.4 23.84-.4 23.84h59.05s20.87-88.51-29.76-97.95Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M133.18 106.86c20.73 46.93-12 57.15-22.33 36.6 0 0-1.1.48-7 .89-7 .49-5.28-1.28-5.28-1.28 0 27.4 9.65 45.41 23.1 52.15l27.33-.46 13.64-63.22-29.46-24.68Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M109.71 93.92s1.77-1.88 5.9-2.55a9.283 9.283 0 0 1 6.94 1.65l-7.91 4.46-4.93-3.56Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB850",
    d: "m160.98 43.49 3.45-3.44a1 1 0 0 0 0-1.33.937.937 0 0 0-1.33 0l-3.46 3.45-3.44-3.45a.937.937 0 0 0-1.33 0 .942.942 0 0 0 0 1.33l3.44 3.44-3.44 3.45a.939.939 0 0 0 .66 1.6 1 1 0 0 0 .67-.27l3.44-3.45 3.45 3.45a.933.933 0 0 0 .66.27 1 1 0 0 0 .67-.27 1 1 0 0 0 0-1.33l-3.44-3.45Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M108.46 86.42s3.51 10.13 2.22 13c-1.29 2.87 12.09-1.56 12.09-1.56l-3.64-15.54-10.67 4.1Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF99",
    d: "m111.24 86.7 2.65-7.21s3-3.51 2-5.71v-1.37c-4.71-2.28-8.52-6.26-9.53-9.53-.309.374-.593.768-.85 1.18a40.457 40.457 0 0 0-3.38 8c-.58 0-2.75-.61-3.22-.16-.47.45 2.25 3.44 2.25 3.44-.05.21-.11.42-.16.62-.61 2.46-1.24 5.42-.25 7.84.79 4.46 7.14 4.43 10.49 2.9ZM124.11 73.26c-.59-2-2.46-2.38-4.1-2.32a11.225 11.225 0 0 1-1.62 8.36c3.15.02 6.75-2.6 5.72-6.04Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA7D6A",
    d: "M109.07 74.32a2.194 2.194 0 0 1-1.923 2.79 2.19 2.19 0 0 1-.777-4.29 2.181 2.181 0 0 1 2.7 1.5Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#93372B",
    d: "M104.7 71.32a.449.449 0 0 1-.29-.56l.31-1.05a.45.45 0 0 1 .56-.29.437.437 0 0 1 .29.55l-.31 1a.467.467 0 0 1-.206.293.455.455 0 0 1-.354.057Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#C65347",
    d: "M100.64 80.25a1.11 1.11 0 0 1-.46-.09.268.268 0 0 1-.15-.36.282.282 0 0 1 .36-.15c.82.34 1.84-1.12 2.16-1.71a.28.28 0 0 1 .49.27c-.06.11-1.14 2.04-2.4 2.04Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M113.89 79.49a12.069 12.069 0 0 0 1.79-3c-.34-1.67-.77-3.53-1.18-4.81a21.989 21.989 0 0 1-2.9-2c-.94 4.79-4.19 11.39-11.32 12.45.077.546.222 1.08.43 1.59.83 4.5 7.18 4.47 10.53 2.94l2.65-7.17Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7C48",
    d: "m3.55 84.4 10.04-2.46 8.73 6.32-10.04 2.46-8.73-6.32Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#29ABCC",
    d: "m12.28 90.72 10.04-2.46-2.69 11.61-10.05 2.45 2.7-11.6Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#3656B3",
    d: "m3.55 84.4 8.73 6.32-2.7 11.6-8.72-6.31L3.55 84.4ZM113.82 16.82l13.13-3.22 7.19 15.6-13.13 3.21-7.19-15.59Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7C48",
    d: "m121.01 32.41 13.13-3.21-9.54 7.48-13.14 3.21 9.55-7.48Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB850",
    d: "m113.82 16.82 7.19 15.59-9.55 7.48-7.18-15.59 9.54-7.48Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#E27A13",
    d: "M103.3 195.04a.283.283 0 0 1-.111-.023.277.277 0 0 1-.148-.164.271.271 0 0 1-.011-.113c0-.28 2.3-28.32 0-49.83-2.3-21.51 10.12-42 10.25-42.24a.265.265 0 0 1 .165-.126.27.27 0 0 1 .205.036.283.283 0 0 1 .09.38c-.12.2-12.45 20.45-10.16 41.89 2.29 21.44 0 49.66 0 49.94a.291.291 0 0 1-.28.25Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB850",
    d: "M107.26 170.8a1.82 1.82 0 1 1 1.87 2.18 2.07 2.07 0 0 1-1.87-2.18ZM107.23 147.45a1.82 1.82 0 1 1 1.79 2.25 2.048 2.048 0 0 1-1.79-2.25ZM109.64 122.9a1.818 1.818 0 0 1 1.464-1.256 1.824 1.824 0 0 1 1.771.765c.194.28.305.61.32.951a1.82 1.82 0 0 1-1.925 1.9 1.989 1.989 0 0 1-1.626-1.566 2.002 2.002 0 0 1-.004-.794Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#045BA8",
    d: "M115.12 89.74c4.55-2.81 8.47-11.85 8.41-17.64 0-1.84-.44-4.21-2.3-5.08-9.08-4.24-7.36-9.41-7.29-9.63.43.37-1.11 5.13 7.51 9.15 1.67.78 2.57 2.7 2.61 5.55.06 6-3.85 15.17-8.82 17.62l-.12.03Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#045BA8",
    d: "M124.56 90.97c2.7-4.67 6.63-17 6.51-23.36-.13-6-9.89-10.36-10-10.4.63-.3 10.38 4 10.51 10.39.13 6.39-3.86 18.94-6.82 23.26a.261.261 0 0 1-.2.11Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE8A76",
    d: "M118.39 79.32a11.163 11.163 0 0 0 1.65-8.22c1.61-.2 3.48.2 4.07 2.18 1.03 3.42-2.57 6.04-5.72 6.04Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0644E",
    d: "M123.06 73.82a2.78 2.78 0 0 0-2.87-1.54 10.996 10.996 0 0 1-1 5.53 4.871 4.871 0 0 0 1.09-.25c2.02-.69 3.25-2.36 2.78-3.74Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFADC",
    d: "M130.93 115.21h-30.9a2.61 2.61 0 0 0-2.61 2.61v45.95a2.61 2.61 0 0 0 2.61 2.61h30.9a2.61 2.61 0 0 0 2.61-2.61v-45.95a2.61 2.61 0 0 0-2.61-2.61Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#29ABCC",
    d: "M124.35 119.98h-17.47v1.75h17.47v-1.75ZM124.35 123.88h-17.47v1.75h17.47v-1.75ZM124.35 135.22h-17.47v1.75h17.47v-1.75ZM124.35 139.12h-17.47v1.75h17.47v-1.75ZM124.35 151h-17.47v1.75h17.47V151ZM124.35 154.89h-17.47v1.75h17.47v-1.75Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M110.64 132.71a81.525 81.525 0 0 1-2.6-10.43c-.36-2.58-1.71-2.9-2.81-2.6-.66.18-1.83.86-1.51 3.1.21 1.51 1.78 7.39-1.33 7.1-3.11-.29-4.56-3.53-4.86-5.09l-.08-3.23s-3.77.11-3.57 5.49c-.89-.07-1.87 3.44-.42 5.08-.26.38-3.14 2.6 2.64 7.78.71.64 2.6 2.83 2.6 2.83l14.27-.12-2.33-9.91Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#C65347",
    d: "M95.78 135.39a9.864 9.864 0 0 1-2.63-3.07c.46-.2 1.22 1.33 2.79 2.62-.01.38-.08.45-.16.45ZM97.25 132.13a8.508 8.508 0 0 1-3.63-5c.5-.08 1.14 2.87 3.77 4.57.03.39-.05.43-.14.43Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M65.81 104.68c0-.39 3.75-1 5.83-5a3.66 3.66 0 0 0 .39-2.23 6.598 6.598 0 0 1-1.92.34c-1.94.09-3.7-.57-4.37-1.64a1.91 1.91 0 0 1 0-2c.72-1.34 2.16-1.65 3.76-.81a5.88 5.88 0 0 1 2.84 3.6 4.78 4.78 0 0 0 2.52-2.27c2.34-4.54-.14-7.41-.25-7.53.32-.23 3 2.93.59 7.71a5.34 5.34 0 0 1-2.79 2.47 4 4 0 0 1-.42 2.54 8.998 8.998 0 0 1-6.14 4.79l-.04.03Zm2-11.39a1.83 1.83 0 0 0-1.7 1.07 1.53 1.53 0 0 0 0 1.62c.59.94 2.25 1.54 4 1.47a6.994 6.994 0 0 0 1.87-.34 5.44 5.44 0 0 0-2.65-3.4 3.57 3.57 0 0 0-1.56-.39l.04-.03Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#3656B3",
    d: "M76.33 32.41a32.41 32.41 0 1 1-64.819 0 32.41 32.41 0 0 1 64.819 0Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFADC",
    d: "M68.22 32.41a24.3 24.3 0 1 1-24.3-24.29 24.29 24.29 0 0 1 24.3 24.29Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7C48",
    d: "M40.43 32.41a3.5 3.5 0 1 0 7.002.02 3.5 3.5 0 0 0-7.002-.02Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7C48",
    d: "M43.92 33.07c-.61-.23-.75-.62-.59-.95l9-18.3a.66.66 0 1 1 1.18.58l-9 18.3a.68.68 0 0 1-.59.37Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7C48",
    d: "M52.56 45.5a.661.661 0 0 1-.54-.28l-8.64-12.43a.67.67 0 0 1 .17-.92.659.659 0 0 1 .92.17l8.63 12.43a.648.648 0 0 1-.16.91.68.68 0 0 1-.38.12Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#045BA8",
    d: "M43.92 16.77a.66.66 0 0 1-.65-.66v-5a.661.661 0 0 1 1.15-.518.66.66 0 0 1 .16.518v5a.66.66 0 0 1-.66.66ZM43.92 54.37a.66.66 0 0 1-.65-.66v-5a.661.661 0 0 1 1.15-.518.66.66 0 0 1 .16.518v5a.66.66 0 0 1-.66.66ZM65.22 33.07h-5a.66.66 0 1 1 0-1.32h5a.66.66 0 0 1 0 1.32ZM27.64 33.07h-5a.66.66 0 1 1 0-1.32h5a.66.66 0 0 1 0 1.32Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M199.95 195.73h-178a.81.81 0 1 1 0-1.62h178a.81.81 0 1 1 0 1.62Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB850",
    d: "M121.19 97.23c19 2.22 53.3 13 57 51.56 6 62.68-85.67 78.39-79.56-6.27 0 0 .35-1.27 7.33-1.27 5.84 0 7 1.25 7 1.25 11.63 31.31 48.87 24.57 21.9-31.67l-13.67-13.6Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#29ABCC",
    d: "M164.92 188.83a30.397 30.397 0 0 0-21.19-4.51 31.671 31.671 0 0 0-21.69 13.61c13.99 6.32 31.18 2.48 42.88-9.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M178.17 148.79c-.187-2-.453-3.917-.8-5.75-.8 14.6-6.1 42.24-33 46.25-29.1 4.33-41.62-18.47-45.4-28 7.89 63.03 84.67 45.03 79.2-12.5Z",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFADC",
    d: "M109.71 93.92s-12.61 10.1-8.59 14.83c5.11 6 12.84-7.55 12.84-7.55s-.59 13.8 9.2 9.83c12.4-5-.61-18-.61-18s-7.55 5.53-12.84.89Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#122C7A",
    d: "M113.96 101.45c-.25-.27.21-5.71.21-5.71.5 0 0 5.48 0 5.48a.255.255 0 0 1-.065.152.253.253 0 0 1-.145.078Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M191.47 146.32c-3.48-.08-5.89-1-7.42-2.81a8.142 8.142 0 0 1-1.76-5.81c.38.08 0 3.21 2.05 5.57 1.46 1.69 3.77 2.59 6.88 2.67 3.39.09 4.84-1.63 5.47-3.08.39-.951.581-1.972.56-3a7.133 7.133 0 0 1-4.75-4.07 1.648 1.648 0 0 1 .87-2.28 2.001 2.001 0 0 1 2.31.65 8.543 8.543 0 0 1 2 5.38c.499.085 1.01.065 1.5-.06a1.48 1.48 0 0 1-1.5.45 7.833 7.833 0 0 1-.6 3.13c-.7 1.51-2.2 3.26-5.61 3.26Zm2.58-12.61a1.481 1.481 0 0 0-.53.11 1.299 1.299 0 0 0-.65 1.81 6.744 6.744 0 0 0 4.37 3.79 8.124 8.124 0 0 0-1.84-5 1.996 1.996 0 0 0-1.35-.68v-.03Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M186.15 73.13h-34.38c-5.584 0-10.11 4.526-10.11 10.11v34.38c0 5.584 4.526 10.11 10.11 10.11h34.38c5.584 0 10.11-4.526 10.11-10.11V83.24c0-5.584-4.526-10.11-10.11-10.11Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#29C7CC",
    d: "M158.28 84.39H148v32.09h10.28V84.39Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB850",
    d: "M174.19 96.67h-10.28v19.8h10.28v-19.8Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFADC",
    d: "M189.92 103.66h-10.28v12.81h10.28v-12.81Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDAA",
    d: "M49.4 81.96s-9 42 10.11 45.13c23.59 3.89 32.07-29.61 53.45-30.4 10.67-.4 13.1 8.89 15.32 15.68 6.66 20.44-11 64.8-60.83 62.88-55.44-2.12-42.18-79.4-31.27-93.18l13.22-.11Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB850",
    d: "M105.47 165.32c-4.6-3.08-13.63-7.5-24.79-4.77a31.828 31.828 0 0 0-19.84 14.06c2.188.352 4.395.569 6.61.65 15.85.6 28.43-3.47 38.02-9.94Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#29C7CC",
    d: "M105.47 165.32c-4.6-3.08-13.63-7.5-24.79-4.77a31.828 31.828 0 0 0-19.84 14.06c2.188.352 4.395.569 6.61.65 15.85.6 28.43-3.47 38.02-9.94Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "m124.04 144.02-9.85-19.27s.93 37.36-40.34 39.1c-41.27 1.74-47.2-37-47.2-37 .72 23.66 10.51 47.26 40.8 48.42 29.84 1.13 48.19-14.3 56.59-31.25Z",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M57.24 68.63a2.64 2.64 0 0 0-2.4-2c-2.24-.27-5.61 1.39-8.32 2.71a2.79 2.79 0 0 1-1.16.34c-.5-.63-2.76-3.48-3.37-4.12-.32-.33-.71-.77-1.11-1.23-1.4-1.61-3.14-3.61-4.69-4.21-1.74-.68-2.63 0-2.91.31a2.099 2.099 0 0 0-.53-.24 2.46 2.46 0 0 0-2.53.88 2.701 2.701 0 0 0-2.44-.25 1.89 1.89 0 0 0-1.1 1.57c-.45 4.18 6 10 8.08 11.32 2.08 1.32 1.43 8.31 1.42 8.36-.01.05 1.32 1.59 6.05 1.85 5.45.31 6.94-.79 7-.9.74-3.47.47-8.22 1.38-9a11.647 11.647 0 0 1 3.35-1.89c.41-.17.79-.33 1.17-.51 2.18-1.06 2.2-2.44 2.11-2.99Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#C65347",
    d: "M44.9 74.14c-.52-4.77-7.94-5.47-8-5.48-1.63-1.39-6.64-7.18-6.85-7.42.43-.27 5.44 5.52 7 6.93.9.09 7.86 1 8.14 5.71-.28.26-.28.26-.29.26Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#C65347",
    d: "M41.06 69.66c-.19-.08-8-9.06-8-9.06.38-.33 8.16 8.65 8.16 8.65-.04.39-.1.41-.16.41Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDAA",
    d: "M119.21 96.81s-4.92-2.33-5.91-1.7c-14.55 9.19-25 22.84-26.72 36.55-1.12 8.64 3.41 23 3.74 39.26-.28 10.83-.4 23.84-.4 23.84h59.05s20.87-88.51-29.76-97.95Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M133.18 106.86c20.73 46.93-12 57.15-22.33 36.6 0 0-1.1.48-7 .89-7 .49-5.28-1.28-5.28-1.28 0 27.4 9.65 45.41 23.1 52.15l27.33-.46 13.64-63.22-29.46-24.68Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M109.71 93.92s1.77-1.88 5.9-2.55a9.283 9.283 0 0 1 6.94 1.65l-7.91 4.46-4.93-3.56Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB850",
    d: "m160.98 43.49 3.45-3.44a1 1 0 0 0 0-1.33.937.937 0 0 0-1.33 0l-3.46 3.45-3.44-3.45a.937.937 0 0 0-1.33 0 .942.942 0 0 0 0 1.33l3.44 3.44-3.44 3.45a.939.939 0 0 0 .66 1.6 1 1 0 0 0 .67-.27l3.44-3.45 3.45 3.45a.933.933 0 0 0 .66.27 1 1 0 0 0 .67-.27 1 1 0 0 0 0-1.33l-3.44-3.45Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M108.46 86.42s3.51 10.13 2.22 13c-1.29 2.87 12.09-1.56 12.09-1.56l-3.64-15.54-10.67 4.1Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF99",
    d: "m111.24 86.7 2.65-7.21s3-3.51 2-5.71v-1.37c-4.71-2.28-8.52-6.26-9.53-9.53-.309.374-.593.768-.85 1.18a40.457 40.457 0 0 0-3.38 8c-.58 0-2.75-.61-3.22-.16-.47.45 2.25 3.44 2.25 3.44-.05.21-.11.42-.16.62-.61 2.46-1.24 5.42-.25 7.84.79 4.46 7.14 4.43 10.49 2.9ZM124.11 73.26c-.59-2-2.46-2.38-4.1-2.32a11.225 11.225 0 0 1-1.62 8.36c3.15.02 6.75-2.6 5.72-6.04Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA7D6A",
    d: "M109.07 74.32a2.194 2.194 0 0 1-1.923 2.79 2.19 2.19 0 0 1-.777-4.29 2.181 2.181 0 0 1 2.7 1.5Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#93372B",
    d: "M104.7 71.32a.449.449 0 0 1-.29-.56l.31-1.05a.45.45 0 0 1 .56-.29.437.437 0 0 1 .29.55l-.31 1a.467.467 0 0 1-.206.293.455.455 0 0 1-.354.057Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#C65347",
    d: "M100.64 80.25a1.11 1.11 0 0 1-.46-.09.268.268 0 0 1-.15-.36.282.282 0 0 1 .36-.15c.82.34 1.84-1.12 2.16-1.71a.28.28 0 0 1 .49.27c-.06.11-1.14 2.04-2.4 2.04Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M113.89 79.49a12.069 12.069 0 0 0 1.79-3c-.34-1.67-.77-3.53-1.18-4.81a21.989 21.989 0 0 1-2.9-2c-.94 4.79-4.19 11.39-11.32 12.45.077.546.222 1.08.43 1.59.83 4.5 7.18 4.47 10.53 2.94l2.65-7.17Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF613F",
    d: "m3.55 84.4 10.04-2.46 8.73 6.32-10.04 2.46-8.73-6.32Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#29ABCC",
    d: "m12.28 90.72 10.04-2.46-2.69 11.61-10.05 2.45 2.7-11.6Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#344FB5",
    d: "m3.55 84.4 8.73 6.32-2.7 11.6-8.72-6.31L3.55 84.4ZM113.82 16.82l13.13-3.22 7.19 15.6-13.13 3.21-7.19-15.59Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF613F",
    d: "m121.01 32.41 13.13-3.21-9.54 7.48-13.14 3.21 9.55-7.48Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB850",
    d: "m113.82 16.82 7.19 15.59-9.55 7.48-7.18-15.59 9.54-7.48Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#E27A13",
    d: "M103.3 195.04a.283.283 0 0 1-.111-.023.277.277 0 0 1-.148-.164.271.271 0 0 1-.011-.113c0-.28 2.3-28.32 0-49.83-2.3-21.51 10.12-42 10.25-42.24a.265.265 0 0 1 .165-.126.27.27 0 0 1 .205.036.283.283 0 0 1 .09.38c-.12.2-12.45 20.45-10.16 41.89 2.29 21.44 0 49.66 0 49.94a.291.291 0 0 1-.28.25Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB850",
    d: "M107.26 170.8a1.82 1.82 0 1 1 1.87 2.18 2.07 2.07 0 0 1-1.87-2.18ZM107.23 147.45a1.82 1.82 0 1 1 1.79 2.25 2.048 2.048 0 0 1-1.79-2.25ZM109.64 122.9a1.818 1.818 0 0 1 1.464-1.256 1.824 1.824 0 0 1 1.771.765c.194.28.305.61.32.951a1.82 1.82 0 0 1-1.925 1.9 1.989 1.989 0 0 1-1.626-1.566 2.002 2.002 0 0 1-.004-.794Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M136.41 68.49c1-8.5-8.58-11.9-13.76-13-12.54-2.74-17.86 2.54-16.33 7.42 0 0 2.79 6.83 7.28 8.46.12 1.92-.47 8.05-4.44 10.11-4.75 2.47-8.27 1.84-8.83 4.13-.87 3.56 13.86 8 27.42 6.55 4.89-.56 7.77-16.21 8.66-23.67Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#344FB5",
    d: "M115.12 89.85c-.43-.4-.35-.62-.16-.71 4.63-2.29 8.52-11.28 8.46-17 0-1.8-.43-4.13-2.24-5-9.17-4.28-7.42-9.55-7.34-9.77a.37.37 0 0 1 .48-.23.382.382 0 0 1 .23.48c-.07.2-1.56 4.87 7 8.84 1.71.8 2.64 2.75 2.67 5.65.07 6-3.88 15.25-8.88 17.72a.33.33 0 0 1-.22.02Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#344FB5",
    d: "M124.56 91.08c-.39-.18-.43-.41-.31-.58 2.91-4.25 6.83-16.57 6.7-22.89-.12-6-9.82-10.25-9.91-10.3a.367.367 0 0 1-.203-.203.374.374 0 0 1 .003-.287.392.392 0 0 1 .5-.2c.42.19 10.23 4.54 10.36 11 .13 6.46-3.86 19-6.83 23.32a.378.378 0 0 1-.31.14Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE8A76",
    d: "M118.39 79.32a11.163 11.163 0 0 0 1.65-8.22c1.61-.2 3.48.2 4.07 2.18 1.03 3.42-2.57 6.04-5.72 6.04Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0644E",
    d: "M123.06 73.82a2.78 2.78 0 0 0-2.87-1.54 10.996 10.996 0 0 1-1 5.53 4.871 4.871 0 0 0 1.09-.25c2.02-.69 3.25-2.36 2.78-3.74Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFADC",
    d: "M130.93 115.21h-30.9a2.61 2.61 0 0 0-2.61 2.61v45.95a2.61 2.61 0 0 0 2.61 2.61h30.9a2.61 2.61 0 0 0 2.61-2.61v-45.95a2.61 2.61 0 0 0-2.61-2.61Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#29ABCC",
    d: "M124.35 119.98h-17.47v1.75h17.47v-1.75ZM124.35 123.88h-17.47v1.75h17.47v-1.75ZM124.35 135.22h-17.47v1.75h17.47v-1.75ZM124.35 139.12h-17.47v1.75h17.47v-1.75ZM124.35 151h-17.47v1.75h17.47V151ZM124.35 154.89h-17.47v1.75h17.47v-1.75Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M110.64 132.71a81.525 81.525 0 0 1-2.6-10.43c-.36-2.58-1.71-2.9-2.81-2.6-.66.18-1.83.86-1.51 3.1.21 1.51 1.78 7.39-1.33 7.1-3.11-.29-4.56-3.53-4.86-5.09l-.08-3.23s-3.77.11-3.57 5.49c-.89-.07-1.87 3.44-.42 5.08-.26.38-3.14 2.6 2.64 7.78.71.64 2.6 2.83 2.6 2.83l14.27-.12-2.33-9.91Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#C65347",
    d: "M95.78 135.39a9.864 9.864 0 0 1-2.63-3.07c.46-.2 1.22 1.33 2.79 2.62-.01.38-.08.45-.16.45ZM97.25 132.13a8.508 8.508 0 0 1-3.63-5c.5-.08 1.14 2.87 3.77 4.57.03.39-.05.43-.14.43Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M65.81 104.68c0-.39 3.75-1 5.83-5a3.66 3.66 0 0 0 .39-2.23 6.598 6.598 0 0 1-1.92.34c-1.94.09-3.7-.57-4.37-1.64a1.91 1.91 0 0 1 0-2c.72-1.34 2.16-1.65 3.76-.81a5.88 5.88 0 0 1 2.84 3.6 4.78 4.78 0 0 0 2.52-2.27c2.34-4.54-.14-7.41-.25-7.53.32-.23 3 2.93.59 7.71a5.34 5.34 0 0 1-2.79 2.47 4 4 0 0 1-.42 2.54 8.998 8.998 0 0 1-6.14 4.79l-.04.03Zm2-11.39a1.83 1.83 0 0 0-1.7 1.07 1.53 1.53 0 0 0 0 1.62c.59.94 2.25 1.54 4 1.47a6.994 6.994 0 0 0 1.87-.34 5.44 5.44 0 0 0-2.65-3.4 3.57 3.57 0 0 0-1.56-.39l.04-.03Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#344FB5",
    d: "M76.33 32.41a32.41 32.41 0 1 1-64.819 0 32.41 32.41 0 0 1 64.819 0Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFADC",
    d: "M68.22 32.41a24.3 24.3 0 1 1-24.3-24.29 24.29 24.29 0 0 1 24.3 24.29Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF613F",
    d: "M40.43 32.41a3.5 3.5 0 1 0 7.002.02 3.5 3.5 0 0 0-7.002-.02Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF613F",
    d: "M43.92 33.07c-.61-.23-.75-.62-.59-.95l9-18.3a.66.66 0 1 1 1.18.58l-9 18.3a.68.68 0 0 1-.59.37Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF613F",
    d: "M52.56 45.5a.661.661 0 0 1-.54-.28l-8.64-12.43a.67.67 0 0 1 .17-.92.659.659 0 0 1 .92.17l8.63 12.43a.648.648 0 0 1-.16.91.68.68 0 0 1-.38.12Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#344FB5",
    d: "M43.92 16.77a.66.66 0 0 1-.65-.66v-5a.661.661 0 0 1 1.15-.518.66.66 0 0 1 .16.518v5a.66.66 0 0 1-.66.66ZM43.92 54.37a.66.66 0 0 1-.65-.66v-5a.661.661 0 0 1 1.15-.518.66.66 0 0 1 .16.518v5a.66.66 0 0 1-.66.66ZM65.22 33.07h-5a.66.66 0 1 1 0-1.32h5a.66.66 0 0 1 0 1.32ZM27.64 33.07h-5a.66.66 0 1 1 0-1.32h5a.66.66 0 0 1 0 1.32Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M199.95 195.73h-178a.81.81 0 1 1 0-1.62h178a.81.81 0 1 1 0 1.62Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDAA",
    d: "M121.19 97.23c19 2.22 53.3 13 57 51.56 6 62.68-85.67 78.39-79.56-6.27 0 0 .35-1.27 7.33-1.27 5.84 0 7 1.25 7 1.25 11.63 31.31 48.87 24.57 21.9-31.67l-13.67-13.6Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#29C7CC",
    d: "M164.92 188.83a30.397 30.397 0 0 0-21.19-4.51 31.671 31.671 0 0 0-21.69 13.61c13.99 6.32 31.18 2.48 42.88-9.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M178.17 148.79c-.187-2-.453-3.917-.8-5.75-.8 14.6-6.1 42.24-33 46.25-29.1 4.33-41.62-18.47-45.4-28 7.89 63.03 84.67 45.03 79.2-12.5Z",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFADC",
    d: "M109.71 93.92s-12.61 10.1-8.59 14.83c5.11 6 12.84-7.55 12.84-7.55s-.59 13.8 9.2 9.83c12.4-5-.61-18-.61-18s-7.55 5.53-12.84.89Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#122C7A",
    d: "M113.96 101.45c-.25-.27.21-5.71.21-5.71.5 0 0 5.48 0 5.48a.255.255 0 0 1-.065.152.253.253 0 0 1-.145.078Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M191.47 146.32c-3.48-.08-5.89-1-7.42-2.81a8.142 8.142 0 0 1-1.76-5.81c.38.08 0 3.21 2.05 5.57 1.46 1.69 3.77 2.59 6.88 2.67 3.39.09 4.84-1.63 5.47-3.08.39-.951.581-1.972.56-3a7.133 7.133 0 0 1-4.75-4.07 1.648 1.648 0 0 1 .87-2.28 2.001 2.001 0 0 1 2.31.65 8.543 8.543 0 0 1 2 5.38c.499.085 1.01.065 1.5-.06a1.48 1.48 0 0 1-1.5.45 7.833 7.833 0 0 1-.6 3.13c-.7 1.51-2.2 3.26-5.61 3.26Zm2.58-12.61a1.481 1.481 0 0 0-.53.11 1.299 1.299 0 0 0-.65 1.81 6.744 6.744 0 0 0 4.37 3.79 8.124 8.124 0 0 0-1.84-5 1.996 1.996 0 0 0-1.35-.68v-.03Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 78.04,
    x2: 78.04,
    y1: 59.18,
    y2: 171.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFB850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF961F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 26.65,
    x2: 124.04,
    y1: 150.03,
    y2: 150.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 44.01,
    x2: 36.79,
    y1: 52.58,
    y2: 99.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFAF99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 45403.2,
    x2: 45541.7,
    y1: 31883.8,
    y2: 38124.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFB850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF961F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 16441.9,
    x2: 16532.6,
    y1: -17250.4,
    y2: -17143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFAF99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 10450.4,
    x2: 10927.2,
    y1: 6273.28,
    y2: 6376.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFAF99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 13837.8,
    x2: 14295.1,
    y1: 8909.96,
    y2: 10859.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFAF99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 56852.3,
    x2: 56852.3,
    y1: 24865.2,
    y2: 28220.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 745.18,
    x2: 745.18,
    y1: 398.42,
    y2: 343.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364BB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F76CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 26.65,
    x2: 124.04,
    y1: 150.03,
    y2: 150.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 44.01,
    x2: 36.79,
    y1: 52.58,
    y2: 99.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFAF99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 45403.2,
    x2: 45541.7,
    y1: 31883.8,
    y2: 38124.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#BDBDAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF961F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 16441.9,
    x2: 16532.6,
    y1: -17250.4,
    y2: -17143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFAF99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 10450.4,
    x2: 10927.2,
    y1: 6273.28,
    y2: 6376.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFAF99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 13837.8,
    x2: 14295.1,
    y1: 8909.96,
    y2: 10859.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFAF99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 56852.3,
    x2: 56852.3,
    y1: 24865.2,
    y2: 28220.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalsNotStarted);
export default __webpack_public_path__ + "static/media/goals-not-started.5a9ba2e48e76af2724096d2ed99b9a41.svg";
export { ForwardRef as ReactComponent };